import { gettingStarted } from './FileStorageConfig';
export const pagesConfig = [...gettingStarted()];
